import { IAccount } from '@modeso/types__aumico-lib-annualreport-be';

export interface IAccountWithRatio extends IAccount {
    closingRatioValue: number | null;
    openingRatioValue: number | null;
}
